import React, { CSSProperties } from 'react';
import { withTranslation } from 'react-i18next';
import { t } from 'i18next';
import './i18n';

import './MetricsDisplay.css'

export interface MetricsDisplayProps { title: String | null, value: String | Object | null, units: String | null, style: CSSProperties | undefined, valueAsIs?:boolean }
export interface MetricsDisplayState { }

export class MetricsDisplay extends React.Component<MetricsDisplayProps> {
    render() {
        var body;
        if (typeof (this.props.value) === 'object') {
            body = this.props.value;
        } else {
            let value;
            if(this.props.value !== null){
                if(this.props.valueAsIs !== undefined && this.props.valueAsIs == true){
                    value = this.props.value;
                } else {
                    value = t(this.props.value,{ns:'trans'});
                }
            }
            let units;
            if(this.props.units !== null){
                units = t(this.props.units.toString(),{ns:'trans'});
            }
            body =
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline', padding: '2px' }}>
                    <label className="metric">{value}</label>
                    <label className="units">{units}</label>
                </div>
        }
        let title;
        if(this.props.title !== null){
            title = t(this.props.title.toString(),{ns:'trans'})
        }
        return (
            <div className="inv-metric-container" style={this.props.style}>
                <label className="metric-title">{title}</label>
                {body}
            </div>
        )
    }
} withTranslation()

export default MetricsDisplay
